const productFiltering = {
    _isShowingMore: false,
    _filtersJSON: null,
    _productsNode: null,
    _filtersWrapperNode: null,
    _filterInners: [],
    _activeFilterTypes: 0,
    _filterPopupNode: null,
    _saveFilterButtonNode: null,
    _clearFilterButtonNode: null,
    _clearFilterButtonNodeMain: null,
    _openFilterButtonNode: null,
    _productsCountSpan: null,
    _maxCategoryToShow: 0,
    _priceRanges: null,
    _dateRangeActive: false,
    _filteredListing: null,

    init() {
        this._filteredListing = document.querySelector('#filtered-listing');
        if (! this._filteredListing) {
            return;
        }

        let productFilteredNode = this._filteredListing.querySelector('.products.switching-list');
        if (! productFilteredNode) {
            return;
        }

        productFilteredNode.addEventListener('switchingListFiltered', () => {
            this._filtersWrapperNode = document.querySelector('.filters');
            if (! this._filtersWrapperNode) {
                return;
            }

            if (this._filtersWrapperNode.dataset.showCategoriesCount) {
                this._maxCategoryToShow = parseInt(this._filtersWrapperNode.dataset.showCategoriesCount);
            }

            this._productsNode = document.querySelectorAll('.js-product-filtering .product');
            this._productsNode.forEach(product => {
                let categories = product.dataset.f_terms.split(',');
                let labels = product.dataset.f_post_tags.split(',');
                let languages = product.dataset.languages ? product.dataset.languages.split(',') : [];
                let priceText = product.querySelector('.price-number')
                    ? product.querySelector('.price-number').textContent.replace(/\s+/g, '')
                    : null;
                let priceNumber = priceText ? parseFloat(priceText) : 0;
                let stockStatus = product.dataset.stock;

                let dateArray = [];
                if (product.dataset.event_date) {
                    dateArray = product.dataset.event_date.split(',');
                }

                product._filter = {
                    categories,
                    languages,
                    priceNumber,
                    stockStatus,
                    labels,
                    date: dateArray
                };
            });

            this._filtersJSON = Object.values(JSON.parse(this._filteredListing.dataset.json));
            this._filtersJSON.forEach((filter, index) => this._renderFilter(filter, index));

            let priceFilter = this._filtersJSON.find(filter => filter.filterBy === 'price');
            if (priceFilter) {
                this._priceRanges = priceFilter.items;
                this._priceRanges.forEach(price => {
                    price.value = price.id.split('-').map(value =>
                        value === '*' ? Infinity : Number(value)
                    );
                });
            }

            let dateFilter = this._filtersJSON.find(filter => filter.filterBy === 'date');

            if (dateFilter) {
                this._renderDateRangePicker();
                this._initRangePicker(document.querySelector('#date_range'));
            }

            this._filterPopupNode = document.querySelector('.product-filtering-popup');
            this._openFilterButtonNode = this._filteredListing.querySelector('.js-openProductFilters');
            this._clearFilterButtonNodeMain = this._filteredListing.querySelector('.js-clear-filters');
            this._clearFilterButtonNode = document.querySelector('#clear-all');
            this._saveFilterButtonNode = document.querySelector('#save');

            if (this._saveFilterButtonNode && this._saveFilterButtonNode.dataset.text) {
                this._saveFilterButtonNode.textContent = this._saveFilterButtonNode.dataset.text;
            }

            this._productsCountSpan = document.querySelector('.js-main-products-count');

            // 1) Načteme filtry z URL a nastavíme je do formuláře
            //this._readFiltersFromURL();

            this._attachEventListeners();
        });
    },

    hidePopup() {
        document.querySelector('.product-filtering-popup').hidden = true;

        let inputs = this._filtersWrapperNode.querySelectorAll('input');
        if (this._activeFilterTypes === 0) {
            inputs.forEach(input => {
                input.checked = false;
            });
            this._setProductsCountText(this._productsNode.length);
        }
    },

    _renderFilter(data) {
        if (! data.items || data.items.length === 0) {
            if (! data.value) {
                return;
            }
        }

        let filteredItems = [];
        if (data.items) {
            filteredItems = data.items.filter(item => {
                if (data.filterBy === 'category') {
                    return Array.from(this._productsNode).some(product =>
                        product._filter.categories.includes(String(item.id))
                    );
                }
                if (data.filterBy === 'tag') {
                    return Array.from(this._productsNode).some(product =>
                        product._filter.labels.includes(String(item.id))
                    );
                }
                return true;
            });
        }

        if (! filteredItems.length > 0 && ! data.value) {
            return;
        }

        let filterWrapper = document.createElement('div');
        let heading = document.createElement('h3');
        heading.textContent = data.heading;

        let filterInner = document.createElement('div');
        filterInner.style.display = 'flex';
        filterInner.style.flexWrap = 'wrap';
        filterInner.style.gap = '0.5rem';

        this._filterInners.push(filterInner);

        if (filteredItems.length > 0) {
            filteredItems.forEach((item, index) => {
                let label = document.createElement('label');
                let input = document.createElement('input');
                let span = document.createElement('span');

                input.type = 'checkbox';
                input.name = data.filterBy;
                input.value = item.id;
                input.id = item.id;

                label.appendChild(input);
                span.textContent = item.name;
                label.appendChild(span);
                filterInner.appendChild(label);

                if (index >= this._maxCategoryToShow) {
                    label.hidden = true;
                }
            });
        } else if (data.value) {
            let subheading = document.createElement('h4');
            subheading.style.fontSize = '16px';
            subheading.textContent = data.subheading;

            let label = document.createElement('label');
            label.classList.add('switch');

            let input = document.createElement('input');
            input.type = 'checkbox';
            input.name = data.filterBy;
            input.value = data.value;
            input.id = data.value;

            let span = document.createElement('span');
            span.classList.add('slider', 'round');

            label.appendChild(input);
            label.appendChild(span);

            filterInner.style.flexWrap = 'nowrap';
            filterInner.style.justifyContent = 'space-between';
            filterInner.style.alignItems = 'center';
            filterInner.appendChild(subheading);
            filterInner.appendChild(label);
        }

        if (filterInner.childNodes.length) {
            filterWrapper.appendChild(heading);
            filterWrapper.appendChild(filterInner);

            if (filteredItems.length > this._maxCategoryToShow) {
                this._createToggleButton(
                    'showMore',
                    this._filtersWrapperNode.dataset.showMore,
                    () => this._toggleFilters(filterInner, filterWrapper),
                    filterWrapper
                );
                this._createToggleButton(
                    'showLess',
                    this._filtersWrapperNode.dataset.showLess,
                    () => this._toggleFilters(filterInner, filterWrapper),
                    filterWrapper,
                    true
                );
            }

            this._filtersWrapperNode.appendChild(filterWrapper);
        }
    },

    _createToggleButton(type, textContent, callback, filterWrapper, hidden = false) {
        let button = document.createElement('button');
        button.type = 'button';
        button.textContent = textContent;
        button.classList.add('filters__moreLink');
        button.style.backgroundColor = 'white';
        button.style.cursor = 'pointer';

        if (hidden) {
            button.hidden = true;
        }

        button.addEventListener('click', callback);
        filterWrapper.appendChild(button);
    },

    _toggleFilters(filterInner, filterWrapper) {
        this._isShowingMore = ! this._isShowingMore;
        this._toggleLabelsVisibility(filterInner);
        this._toggleButtonsVisibility(filterWrapper);
    },

    _toggleLabelsVisibility(filterInner) {
        let labels = filterInner.querySelectorAll('label');
        labels.forEach((label, index) => {
            if (index >= this._maxCategoryToShow) {
                label.hidden = ! this._isShowingMore;
            }
        });
    },

    _toggleButtonsVisibility(filterWrapper) {
        let moreButton = filterWrapper.querySelector('.filters__moreLink');
        let lessButton = moreButton.nextElementSibling;
        moreButton.hidden = this._isShowingMore;
        lessButton.hidden = ! this._isShowingMore;
    },

    _filterProducts(shouldHidePopup = true) {
        let selectedFilters = this._getSelectedFilters();
        let productContainer = document.querySelector('.productContainer');
        let productFilteredHeading = document.querySelector('.product-filtered-heading');
        let mainEshopPageNodes = document.querySelectorAll('.filterProducts');
        this._activeFilterTypes = Object.values(selectedFilters).filter(filter => filter.length > 0).length;

        if (productContainer) {
            if (this._activeFilterTypes > 0 || Object.keys(selectedFilters).length !== 0) {
                if (this._filteredListing) {
                    this._filteredListing.classList.add('section-padding');
                }
                if (productFilteredHeading) {
                    productFilteredHeading.style = '';
                }
                productContainer.hidden = false;
                mainEshopPageNodes.forEach(section => (section.style.display = 'none'));
            } else {
                if (this._filteredListing) {
                    this._filteredListing.classList.remove('section-padding');
                }
                if (productFilteredHeading) {
                    productFilteredHeading.style = 'display: none';
                }
                productContainer.hidden = true;
                mainEshopPageNodes.forEach(section => (section.style.display = 'block'));
            }
        }

        if (this._activeFilterTypes > 0) {
            this._openFilterButtonNode.dataset.count = this._activeFilterTypes;
            this._clearFilterButtonNodeMain.hidden = false;
        } else {
            if (this._openFilterButtonNode) {
                this._openFilterButtonNode.dataset.count = '';
                this._clearFilterButtonNodeMain.hidden = true;
            }
        }

        let activeCount = 0;
        let updates = [];
        this._productsNode.forEach(product => {
            let isVisible = this._isProductVisible(product, selectedFilters);
            product.hidden = ! isVisible;
            updates.push(() => {
                product.style.display = isVisible ? 'flex' : 'none';
                product.classList.toggle('active', isVisible);
            });
            if (isVisible) {
                activeCount++;
            }
         });

        requestAnimationFrame(() => updates.forEach(update => update()));

        if (shouldHidePopup) {
            this._filterPopupNode.hidden = true;
        }

        this._setProductsCountText(activeCount);

        //this._setURLParams(selectedFilters);
    },

    _updateProductCountDisplay(ev) {
        let selectedFilters = this._getSelectedFilters();
        let activeCount = Array.from(this._productsNode).filter(product =>
            this._isProductVisible(product, selectedFilters)
        ).length;
        this._setProductsCountText(activeCount, ev.target.checked);
    },

    _isProductVisible(product, selectedFilters) {
        if (selectedFilters['category']) {
            if (! selectedFilters['category'].some(category => product._filter.categories.includes(category))) {
                return false;
            }
        }

        if (selectedFilters['tag']) {
            if (! selectedFilters['tag'].some(tag => product._filter.labels.includes(tag))) {
                return false;
            }
        }

        if (selectedFilters['language']) {
            if (! selectedFilters['language'].some(language => product._filter.languages.includes(language))) {
                return false;
            }
        }

        if (selectedFilters['price']) {
            let isInSomeRange = selectedFilters['price'].some(priceRangeSelected => {
                let matchedPriceRange = this._priceRanges.find(pr => pr.id === priceRangeSelected).value;
                let [min, max] = matchedPriceRange;
                return product._filter.priceNumber >= min && product._filter.priceNumber <= max;
            });
            if (! isInSomeRange) {
                return false;
            }
        }

        if (selectedFilters['availability']) {
            if (! selectedFilters['availability'].includes(product._filter.stockStatus)) {
                return false;
            }
        }

        if (selectedFilters['dateRange']) {
            let { start, end } = selectedFilters.dateRange;

            let productDates = product._filter.date;
            if (! productDates || ! productDates.length) {
                return false;
            }

            let inRange = productDates.some(d => {
                let m = moment(d, 'DD-MM-YYYY', true);
                if (! m.isValid()) {
                    return false;
                }

                return m.isBetween(start, end, null, '[]');
            });

            if (! inRange) {
                return false;
            }
        }

        return true;
    },

    _setProductsCountText(count) {
        let inputs = Array.from(this._filtersWrapperNode.querySelectorAll('input'));
        let isChecked = inputs.some(input => input.checked);

        if ((isChecked && count <= this._productsNode.length) || this._dateRangeActive) {
            this._saveFilterButtonNode.textContent = this._saveFilterButtonNode.dataset.text + ' ' + count;
            this._productsCountSpan.textContent = '(' + count + ')';
        } else {
            this._saveFilterButtonNode.textContent = this._saveFilterButtonNode.dataset.text;
            this._productsCountSpan.textContent = '(' + count + ')';
        }
    },

    _getSelectedFilters() {
        let formData = new FormData(this._filtersWrapperNode);
        let selectedFilters = {};

        for (const [key, value] of formData.entries()) {
            if (! selectedFilters[key]) {
                selectedFilters[key] = [];
            }
            selectedFilters[key].push(value);
        }

        if (this._dateRangeActive) {
            let dateRangeNode = document.querySelector('#date_range');
            if (dateRangeNode) {
                let startDate = dateRangeNode.getAttribute('data-startdate');
                let endDate   = dateRangeNode.getAttribute('data-enddate');

                if (startDate && endDate) {
                    selectedFilters.dateRange = {
                        start: startDate, // 'YYYY-MM-DD'
                        end: endDate      // 'YYYY-MM-DD'
                    };
                }
            }
        }

        return selectedFilters;
    },

    _attachEventListeners() {
        this._filtersWrapperNode.addEventListener('change', ev => {
            if (ev.target.tagName === 'INPUT') {
                this._updateProductCountDisplay(ev);
            }
        });

        [this._clearFilterButtonNode, this._clearFilterButtonNodeMain].forEach(button =>
            button.addEventListener('click', () => this._clearAllFilters(false))
        );

        this._saveFilterButtonNode.addEventListener('click', () => this._filterProducts());
    },

    _clearAllFilters(shouldHidePopup = true) {
        let inputs = this._filtersWrapperNode.querySelectorAll('input');
        inputs.forEach(input => {
            input.checked = false;
        });
        this._filterProducts(shouldHidePopup);
    },

    /*_setURLParams(selectedFilters) {
        let params = new URLSearchParams();

        for (const [filterName, values] of Object.entries(selectedFilters)) {
            if (filterName === 'dateRange') {
                continue;
            }
            values.forEach(v => {
                params.append(filterName, v);
            });
        }

        if (selectedFilters.dateRange) {
            let { start, end } = selectedFilters.dateRange;
            // Např. dateStart=YYYY-MM-DD a dateEnd=YYYY-MM-DD
            params.set('dateStart', start);
            params.set('dateEnd', end);
        }

        const newUrl = window.location.pathname + '?' + params.toString();
        window.history.replaceState({}, '', newUrl);
    },*/

    /*_readFiltersFromURL() {
        let params = new URLSearchParams(window.location.search);

        for (let [filterName, value] of params.entries()) {
            if (filterName === 'dateStart' || filterName === 'dateEnd') {
                // Tohle vyřešíme zvlášť
                continue;
            }
            let input = this._filtersWrapperNode.querySelector(
                `input[name="${filterName}"][value="${value}"]`
            );
            if (input) {
                input.checked = true;
            }
        }

        if(params.get('dateStart') && params.get('dateEnd')) {
            let dateRangeNode = document.querySelector('#date_range');
            let picker = jQuery(dateRangeNode).data('daterangepicker');

            if (dateRangeNode) {
                let dateStart = moment(params.get('dateStart'));
                let dateEnd   = moment(params.get('dateEnd'));

                const formattedStartDate = this._formatDate(dateStart, pctVars.l18n.weekDays);
                const formattedEndDate = this._formatDate(dateEnd, pctVars.l18n.weekDays) + ' ' + dateEnd.format('YYYY');

                picker.setStartDate(dateStart);
                picker.setEndDate(dateEnd);

                jQuery(dateRangeNode).val(`${formattedStartDate} – ${formattedEndDate}`);

                jQuery(dateRangeNode).attr('data-startdate', moment(dateStart).format('YYYY-MM-DD'));
                jQuery(dateRangeNode).attr('data-enddate', moment(dateEnd).format('YYYY-MM-DD'));
                jQuery(dateRangeNode).attr('data-daycount', dateEnd.diff(dateStart, 'days') + 1);

                this._dateRangeActive = true;
            }
        }
    },*/

    _initRangePicker(node) {
        let self = this;
        let currentDate = moment();
        let initialStartDate = currentDate;
        let initialEndDate = currentDate.clone().add(1, 'year');

        self._rangePickerObject = new daterangepicker(node, {
            'locale': {
                'format': 'DD. MM. YYYY',
                'separator': ' – ',
                'applyLabel': pctVars.l18n.apply,
                'cancelLabel': pctVars.l18n.cancel,
                'fromLabel': pctVars.l18n.from,
                'toLabel': pctVars.l18n.to,
                'customRangeLabel': 'Custom',
                'weekLabel': 'W',
                'daysOfWeek': pctVars.l18n.weekDays,
                'monthNames': pctVars.l18n.months,
                'firstDay': 1,
            },
            'opens': 'left',
            'startDate': initialStartDate,
            'endDate': initialEndDate,
            'minDate': this.currentDate,
        });

        jQuery(node).on( 'apply.daterangepicker', function(ev, picker) {
            const formattedStartDate = self._formatDate(picker.startDate, pctVars.l18n.weekDays);
            const formattedEndDate = self._formatDate(picker.endDate, pctVars.l18n.weekDays) + ' ' + picker.endDate.format('YYYY');

            node.value = `${formattedStartDate} – ${formattedEndDate}`;

            node.setAttribute('data-startdate', picker.startDate.format('YYYY-MM-DD'));
            node.setAttribute('data-enddate', picker.endDate.format('YYYY-MM-DD'));
            node.setAttribute('data-daycount', picker.endDate.diff(picker.startDate, 'days') + 1);

            self._dateRangeActive = true;
            self._filterProducts(false);
        });


        jQuery(node).on( 'cancel.daterangepicker', function(ev, picker) {
            self._setInitialDateState(node);
        });

        let clearBtn = document.querySelector('.listing-controls__date__range__delete');

        if (clearBtn) {
            clearBtn.addEventListener('click', () => {
                self._setInitialDateState(node);
            });
        }
    },

    _setInitialDateState(node) {
        const now = moment();
        const nextYear = moment().add(1, 'year');

        this._rangePickerObject.setStartDate(now);
        this._rangePickerObject.setEndDate(nextYear);

        const formattedStartDate = this._formatDate(this._rangePickerObject.startDate, pctVars.l18n.weekDays);
        const formattedEndDate = this._formatDate(this._rangePickerObject.endDate, pctVars.l18n.weekDays) + ' ' + this._rangePickerObject.endDate.format('YYYY');

        node.value = `${formattedStartDate} – ${formattedEndDate}`;

        node.setAttribute('data-startdate', this._rangePickerObject.startDate.format('YYYY-MM-DD'));
        node.setAttribute('data-enddate', this._rangePickerObject.endDate.format('YYYY-MM-DD'));
        node.setAttribute('data-daycount', this._rangePickerObject.endDate.diff(this._rangePickerObject.startDate, 'days') + 1);
        this._dateRangeActive = false;
        this._filterProducts(false);
    },

    _formatDate(date, daysOfWeek) {
		return date.format('ddd DD. MM.').replace('Sun', daysOfWeek[0]).replace('Mon', daysOfWeek[1]).replace('Tue', daysOfWeek[2]).replace('Wed', daysOfWeek[3]).replace('Thu', daysOfWeek[4]).replace('Fri', daysOfWeek[5]).replace('Sat', daysOfWeek[6]);
	},

    _renderDateRangePicker() {
        let datePickerWrapper = document.querySelector('.listing-controls__date');

        if (! datePickerWrapper) {
            return;
        }

        datePickerWrapper.innerHTML = '<button class="listing-controls__date__pref" disabled="disabled" data-sikmon="arrowLeft"></button><input type="text" readonly="" id="date_range" placeholder="vyberte datum" data-daycount="366" data-startdate="2025-02-03" data-enddate="2026-02-03"> <button class="listing-controls__date__range__delete" data-sikmon="closeDelete"></button><button class="listing-controls__date__next" disabled="disabled" data-sikmon="arrowRight"></button>';
    }
};

window.productFiltering = productFiltering;
export { productFiltering };
